const errorMessages: object = {
  errorMessage: [
    { emptyTextField: 'Ju Lutem Plotesoni Fushën' },
    { emailValidation: 'Ky email eshte i perdorur' },
    { phoneNumberValidation: 'Numri i telefonit duhet te jete 13 shifra' },
    {
      passwordConfirmation: 'Konfirmimi i password nuk perputhet me passwordin',
    },
    { passwordValidation: 'Password duhet te jete te pakten 8 karaktere' },
  ],
}
export { errorMessages }

const hasFavorites: boolean = Boolean(process.env.VUE_APP_HAS_FAVORITES)
const userGadgetList: object = [
  {
    id: 1,
    name: '/profile/information',
    userProfile: 'Te Dhënat',
    icon: 'fa fa-user-o',
    show: true,
  },
  {
    id: 2,
    name: '/profile/addresses',
    userProfile: 'Adresat',
    icon: 'fa fa-map-o',
    show: true,
  },
  {
    id: 3,
    name: '/profile/favorites',
    userProfile: 'Të Preferuarat',
    icon: 'fa fa-heart-o',
    show: hasFavorites,
  },
]

export { userGadgetList }

const listOfCities: any = {
  cities: [
    { id: 1, name: 'Tirana' },
    { id: 2, name: 'Durrës' },
    { id: 3, name: 'Vlorë' },
    { id: 4, name: 'Elbasan' },
    { id: 5, name: 'Shkodër' },
    { id: 6, name: 'Fier' },
    { id: 7, name: 'Kamëz' },
    { id: 8, name: 'Korçë' },
    { id: 9, name: 'Berat' },
    { id: 10, name: 'Lushnjë' },
    { id: 11, name: 'Pogradec' },
    { id: 12, name: 'Kavajë' },
    { id: 13, name: 'Gjirokastër' },
    { id: 14, name: 'Fushë-Krujë' },
    { id: 15, name: 'Sarandë' },
    { id: 16, name: 'Laç' },
    { id: 17, name: 'Kukës' },
    { id: 18, name: 'Sukth' },
    { id: 19, name: 'Patos' },
    { id: 20, name: 'Lezhë' },
    { id: 21, name: 'Mamurras' },
    { id: 22, name: 'Peshkopi' },
    { id: 23, name: 'Kuçovë' },
    { id: 24, name: 'Krujë' },
    { id: 25, name: 'Vorë' },
    { id: 26, name: 'Burrel' },
    { id: 27, name: 'Rrëshen' },
    { id: 28, name: 'Milot' },
    { id: 29, name: 'Divjakë' },
    { id: 30, name: 'Gramsh' },
    { id: 31, name: 'Bulqizë' },
    { id: 32, name: 'Vau i Dejës' },
    { id: 33, name: 'Shëngjin' },
    { id: 34, name: 'Klos' },
    { id: 35, name: 'Ballsh' },
    { id: 36, name: 'Shijak' },
    { id: 37, name: 'Ura Vajguror' },
    { id: 38, name: 'Rrogozhinë' },
    { id: 39, name: 'Librazhd' },
    { id: 40, name: 'Cërrik' },
    { id: 41, name: 'Manëz' },
    { id: 42, name: 'Peqin' },
    { id: 43, name: 'Bilisht' },
    { id: 44, name: 'Krumë' },
    { id: 45, name: 'Përmet' },
    { id: 46, name: 'Prrenjas' },
    { id: 47, name: 'Delvinë' },
    { id: 48, name: 'Orikum' },
    { id: 49, name: 'Bajram Curr' },
    { id: 50, name: 'Roskovec' },
    { id: 51, name: 'Rubik' },
    { id: 52, name: 'Tepelenë' },
    { id: 53, name: 'Poliçan' },
    { id: 54, name: 'Maliq' },
    { id: 55, name: 'Çorovodë' },
    { id: 56, name: 'Ersekë' },
    { id: 57, name: 'Koplik' },
    { id: 58, name: 'Pukë' },
    { id: 59, name: 'Himarë' },
    { id: 60, name: 'Këlcyrë' },
    { id: 61, name: 'Memaliaj' },
    { id: 62, name: 'Fushë-Arrëz' },
    { id: 63, name: 'Bajzë' },
    { id: 64, name: 'Krrabë' },
    { id: 65, name: 'Selenicë' },
    { id: 66, name: 'Konispol' },
    { id: 67, name: 'Libohovë' },
    { id: 68, name: 'Reps' },
    { id: 69, name: 'Fierzë' },
    { id: 70, name: 'Krastë' },
    { id: 71, name: 'Leskovik' },
    { id: 72, name: 'Finiq' },
    { id: 73, name: 'Ulëz' },
    { id: 74, name: 'Kurbnesh' },
  ],
}
export { listOfCities }

const carouselOption: any = {
  itemPerPage: parseInt(process.env.VUE_APP_CAROUSEL_ITEM_PER_PAGE || 10),
  loop: Boolean(process.env.VUE_APP_CAROUSEL_LOOP || false),
  navigationEnabled: Boolean(process.env.VUE_APP_NAVIGATION_ENABLED || false),
  spacePadding: parseFloat(process.env.VUE_APP_CAROUSEL_SPACE_PADDING || 16),
  speed: parseInt(process.env.VUE_APP_CAROUSEL_SPEED || 1),
  paginationSize: parseInt(process.env.VUE_APP_CAROUSEL_PAGINATION_SIZE || 5),
  paginationActiveColor: process.env.VUE_APP_CAROUSEL_PAGINATION_ACTIVE_COLOR || '#eee',
  pauseOnHover: Boolean(process.env.VUE_APP_CAROUSEL_PAUSE_ON_HOVER || false),
  paginationPadding: parseInt(process.env.VUE_APP_CAROUSEL_PAGINATION_PADDING || 16),
  paginationEnabled: JSON.parse(process.env.VUE_APP_CAROUSEL_PAGINATION_ENABLED || false),
}

export { carouselOption }

const envConfiguration: any = {
  hasFavorites: JSON.parse(process.env.VUE_APP_HAS_FAVORITES || false),
  shoppingCartIcon: process.env.VUE_APP_SHOPPING_CART_ICON || '',
  photoUrl: process.env.VUE_APP_PHOTO_URL || '',
  hasCredits: JSON.parse(process.env.VUE_APP_HAS_CREDITS || false),
  sectorID: process.env.VUE_APP_SECTOR_ID || 0,
  iconSize: process.env.VUE_APP_SHOPPING_CART_ICON_SIZE || 10,
  specialRequestNotes: process.env.VUE_APP_NOTES || '',
  showCategoriesToMainHeader: JSON.parse(process.env.VUE_APP_SHOW_CATEGORIES_IN_MAIN_HEADER || false),
  logoText: process.env.VUE_APP_LOGO_TITLE || '',
  showUserIcon: JSON.parse(process.env.VUE_APP_SHOW_USER_IN_MAIN_HEADER || false),
  businessEmail: process.env.VUE_APP_BUSINESS_EMAIL || '',
  hasLeftCategories: JSON.parse(process.env.VUE_APP_LEFT_CATEGORIES || 'false') || false,
  hasMultiPhotos: JSON.parse(process.env.VUE_APP_HAS_MULTIPHOTOS || 'false') || false,
  showCategoriesToUserHeader: JSON.parse(process.env.VUE_APP_SHOW_CATEGORIES_IN_USER_HEADER || 'false') || false,
}
export { envConfiguration }

export function CarouselNextLabel() {
  return `<div class="navigation-labels next-icon"><i class='fa fa-chevron-right'></i></div>`
}
export function CarouselPrevLabel() {
  return `<div class="navigation-labels prev-icon"><i class='fa fa-chevron-left'></i></div>`
}
